import type { MapItem } from '@web/widgets/map/type/map-widget.type';

export const defaultMapItem: MapItem = {
    address: 'Trafalgar Square, London, UK',
    position: {
        lat: 51.5075401,
        lng: -0.1280525,
    },
    title: 'Trafalgar Square',
};
